// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-headers-align .mat-mdc-expansion-panel-header-title,
.example-headers-align .mat-mdc-expansion-panel-header-description {
  flex-basis: 0;
}

.example-headers-align .mat-mdc-expansion-panel-header-description {
  justify-content: space-between;
  align-items: center;
}

.example-headers-align .mat-mdc-form-field + .mat-mdc-form-field {
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tag-picker/tag-picker.component.scss"],"names":[],"mappings":"AAAA;;EAEE,aAAA;AACF;;AAEA;EACE,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".example-headers-align .mat-mdc-expansion-panel-header-title,\r\n.example-headers-align .mat-mdc-expansion-panel-header-description {\r\n  flex-basis: 0;\r\n}\r\n\r\n.example-headers-align .mat-mdc-expansion-panel-header-description {\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.example-headers-align .mat-mdc-form-field + .mat-mdc-form-field {\r\n  margin-left: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
